import { map, switchMap } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { Command, CommandBase, FilteredCommand, MultiselectCommand } from '../../../core/model/command';
import { InvoiceStatus } from '../../model/const/enum';
import { invoiceCommand } from '../../command/unpaid-invoice';
import { InvoiceService } from '../data/invoice.service';
import { MessageService } from '../../../core/service/message.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { DeliverInvoiceComponent } from '../../component/deliver-invoice/deliver-invoice.component';
import { Invoice } from '../../model/invoice';
import { Observable } from 'rxjs';

@Injectable()
export class SendCommandHandler implements ICommandHandler {
  constructor(
    private _dialogService: ActionWindowService,
    private _injector: Injector,
    private _dataService: InvoiceService,
    private _messageService: MessageService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command.id !== invoiceCommand.send) {
      return false;
    }
    if (command instanceof Command) {
      if (!command.context.attestedDate || !command.context.attestedDate.hasValue()) {
        this._messageService.showMessage('INVOICE.INFORMATION_TEXT.INVOICE_CERTIFIED_BEFORE_SEND');
        return false;
      }
      return command.context;
    }
    if (command instanceof MultiselectCommand) {
      return command.items.length > 0;
    }
    if (command instanceof FilteredCommand) {
      return command.filterProvider && command.totalAffectedItemsControlValue > 0;
    }

    return false;
  }

  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof Command) {
      return this._dialogService.open(DeliverInvoiceComponent, this._injector, null, { invoices: [command.context] }).pipe(
        map(result => {
          (<Invoice>command.context).usedDeliveryMethods = result.usedDeliveryMethods;
          return true;
        })
      );
    }
    if (command instanceof MultiselectCommand) {
      return this._dialogService.open(DeliverInvoiceComponent, this._injector, null, { invoices: command.items }).pipe(
        map(invoices => {
          if (invoices instanceof Array) {
            invoices.forEach(x => {
              command.items.forEach(x => (x.selected = false));
              const invoice = <Invoice>command.items.find(i => i.id === x.id);
              invoice.usedDeliveryMethods = (<Invoice>x).usedDeliveryMethods;
            });
            return true;
          } else throw Error('Wrong response.');
        })
      );
    }
    if (command instanceof FilteredCommand) {
      let selection = {
        filter: command.filterProvider.filterState,
        includedIds: command.includedIds,
        excludedIds: command.excludedIds,
        affectedItemsCount: command.totalAffectedItemsControlValue,
      };
      return this._dataService.sendByFilterSummary(selection).pipe(
        switchMap(summary => {
          let dataContext = {
            invoices: null,
            emailCount: summary.emailCount,
            mailCount: summary.mailCount,
            b2bCount: summary.b2bCount,
            selection: selection,
          };
          return this._dialogService.open(DeliverInvoiceComponent, this._injector, null, dataContext).pipe(map(() => false));
        })
      );
    }
  }
}
